/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon16Regular = forwardRef('MathSumIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.41 3.912C2.67 3.235 3.149 2 4.154 2h8.097a.75.75 0 0 1 0 1.5H5.184l4.039 3.688a1.1 1.1 0 0 1 0 1.624L5.183 12.5h7.067a.75.75 0 0 1 0 1.5H4.153c-1.005 0-1.484-1.235-.742-1.912L7.888 8 3.41 3.912Z" })));
});
